// Header Scripts - Refactored

// Aplica padding-top al body igual a la altura real del header fixed
// y posiciona el countdown timer justo debajo del header
function applyHeaderOffset() {
  var h = document.querySelector('.farmalisto-header-wrapper');
  if (!h) return;
  var headerHeight = h.offsetHeight;
  var countdown = document.querySelector('.gta-content__container');
  if (countdown) {
    countdown.style.top = headerHeight + 'px';
    document.body.style.paddingTop = (headerHeight + countdown.offsetHeight) + 'px';
  } else {
    document.body.style.paddingTop = headerHeight + 'px';
  }
}
document.addEventListener('DOMContentLoaded', applyHeaderOffset);
window.addEventListener('load', applyHeaderOffset);
window.addEventListener('resize', applyHeaderOffset);
document.addEventListener('DOMContentLoaded', function () {
  var h = document.querySelector('.farmalisto-header-wrapper');
  if (h && window.ResizeObserver) {
    new ResizeObserver(applyHeaderOffset).observe(h);
  }
});

// Announcement bar rotator: auto-advances slides, each with its own on-screen duration.
// No manual controls — purely automatic, isolated from the mega-menu init below so it
// keeps working even if window.megaMenuJsonUrl is missing (see early return further down).
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-announcement-rotator]').forEach(function (rotator) {
    var slides = Array.prototype.slice.call(rotator.querySelectorAll('.f-announcement-text'));
    if (slides.length <= 1) return;

    var current = slides.findIndex(function (slide) { return slide.classList.contains('is-active'); });
    if (current < 0) current = 0;
    var timerId = null;

    function scheduleNext() {
      var duration = parseFloat(slides[current].dataset.duration) || 5;
      timerId = setTimeout(function () {
        var next = (current + 1) % slides.length;
        slides[current].classList.remove('is-active');
        slides[next].classList.add('is-active');
        current = next;
        scheduleNext();
      }, duration * 1000);
    }

    scheduleNext();

    // Theme editor: pause rotation and show whichever slide is being edited.
    rotator.addEventListener('shopify:block:select', function (event) {
      clearTimeout(timerId);
      slides[current].classList.remove('is-active');
      var index = slides.indexOf(event.target);
      if (index === -1) return;
      current = index;
      slides[current].classList.add('is-active');
    });

    rotator.addEventListener('shopify:block:deselect', function () {
      scheduleNext();
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const navList = document.querySelector('.f-nav-list');
  const drawerList = document.querySelector('.f-drawer-menu-list');
  const drawer = document.querySelector('.f-mobile-drawer');
  const overlay = document.querySelector('.f-mobile-drawer-overlay');
  const menuBtn = document.querySelector('.f-mobile-menu-btn');
  const closeBtn = document.querySelector('.f-drawer-close');
  
  // Iconos simples para el menú móvil se definen en el archivo liquid (window.mobileIcons)
  const mobileIcons = window.mobileIcons || {};

  
  if (!window.megaMenuJsonUrl) return;

  // Cargar el menú dinámicamente desde el JSON
  fetch(window.megaMenuJsonUrl)
    .then(res => res.json())
    .then(data => {
      if (navList) navList.innerHTML = '';
      if (drawerList) drawerList.innerHTML = '';
      
      // Añadir item de "Ofertas" manualmente al drawer si es necesario o basarse en el JSON
      // (Suponiendo que viene en el JSON)

      const predictiveCategoriesList = document.querySelector('.js-predictive-categories-list');
      if (predictiveCategoriesList) predictiveCategoriesList.innerHTML = '';

      const addCatId = (url, catId) => {
        if (!url || url === '#' || url === '') return url;
        return url.includes('?') ? `${url}&cat_id=${catId}` : `${url}?cat_id=${catId}`;
      };

      // Mismo color que se ve en el hover del mega menú para esa categoría:
      // prioriza el color configurado en el admin (promo) y si no, el del JSON.
      const getFinalHoverColors = (categoryId, category) => {
        const promoObj = window.megaMenuPromos ? window.megaMenuPromos[categoryId] : null;
        const isSet = (val) => val && val !== '' && val !== 'rgba(0,0,0,0)';
        return {
          bg: isSet(promoObj && promoObj.hover_bg) ? promoObj.hover_bg : category.hover_color_bg,
          border: isSet(promoObj && promoObj.hover_border) ? promoObj.hover_border : category.hover_color_border
        };
      };

      const formatDisplayTitle = (text) => {
        if (!text) return text;
        return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
      };

      data.forEach(category => {
        const categoryId = category.id;
        const iconSvg = mobileIcons[categoryId] || mobileIcons['default'];

        const { bg: finalHoverBg, border: finalHoverBorder } = getFinalHoverColors(categoryId, category);
        
        // 1. DESKTOP MEGA MENU
        if (navList) {
          const li = document.createElement('li');
          li.className = 'f-nav-item-container';
          li.style.setProperty('--hover-bg', finalHoverBg);
          li.style.setProperty('--hover-border', finalHoverBorder);
          li.style.setProperty('--mega-menu-line-color', finalHoverBorder);
          
          let html = `<a href="${addCatId(category.url, categoryId)}" class="f-nav-item f-nav-item--${categoryId}">
              ${formatDisplayTitle(category.name)}
              ${category.subcategories.length > 0 ? '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" stroke="currentColor"><path d="M1 1.5L6 6.5L11 1.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' : ''}
            </a>`;
            
          if (category.subcategories.length > 0) {
            html += `<div class="f-mega-menu"><div class="f-mega-menu-content"><div class="f-mega-menu-columns">`;
            category.subcategories.forEach(sub => {
              // Solo mostramos la subcategoría (N1); las clasificaciones (N2) ya no se listan aquí.
              const subUrl = sub.url ? addCatId(sub.url, categoryId) : `/search?type=product&q=${encodeURIComponent(sub.name)}&cat_id=${categoryId}`;
              html += `<a href="${subUrl}" class="f-mega-menu-subcat">${formatDisplayTitle(sub.name)}</a>`;
            });
            html += `</div>`;
            
            const promoObj = window.megaMenuPromos ? window.megaMenuPromos[categoryId] : null;
            if (promoObj) {
              if (promoObj.bg_url) {
                html += `<img src="${promoObj.bg_url}" class="f-mega-menu-bg-img" alt="" onerror="this.style.display='none'" />`;
              }
              if (promoObj.url && !promoObj.url.includes('no-image')) {
                html += `<div class="f-mega-menu-promo"><img src="${promoObj.url}" alt="Promoción" class="f-promo-img" style="width: ${promoObj.width}px;" /></div>`;
              }
            }
            html += `</div></div>`;
          }
          li.innerHTML = html;
          navList.appendChild(li);
        }

        // 2. MOBILE DRAWER MENU
        if (drawerList) {
          const liDrawer = document.createElement('li');
          liDrawer.className = 'f-drawer-menu-item';
          liDrawer.style.setProperty('--hover-bg', finalHoverBg || '#f9ede7');
          liDrawer.style.setProperty('--hover-border', finalHoverBorder || '#008300');
          
          let hasSub = category.subcategories && category.subcategories.length > 0;
          
          let drawerHtml = `<a href="${hasSub ? '#' : category.url}" class="f-drawer-menu-link">
            <span class="f-drawer-menu-icon" style="color: ${finalHoverBorder};">${iconSvg}</span>
            <span class="f-drawer-menu-text">${formatDisplayTitle(category.name)}</span>
            ${hasSub ? '<svg class="f-drawer-menu-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>' : ''}
          </a>`;
          
          if (hasSub) {
            drawerHtml += `<div class="f-drawer-submenu">`;
            drawerHtml += `<div class="f-drawer-submenu-links">`;
            category.subcategories.forEach(sub => {
              // Solo mostramos la subcategoría (N1); las clasificaciones (N2) ya no se listan aquí.
              const subUrl = sub.url ? addCatId(sub.url, categoryId) : `/search?type=product&q=${encodeURIComponent(sub.name)}&cat_id=${categoryId}`;
              drawerHtml += `<a href="${subUrl}" class="f-drawer-sublink f-drawer-sublink--bold">${formatDisplayTitle(sub.name)}</a>`;
            });
            drawerHtml += `</div>`;
            
            const promoObj = window.megaMenuPromos ? window.megaMenuPromos[categoryId] : null;
            if (promoObj && (promoObj.bg_url || (promoObj.url && !promoObj.url.includes('no-image')))) {
              let bgStyle = promoObj.bg_url ? `background-image: url('${promoObj.bg_url}'); background-size: cover; background-position: center; background-color: var(--hover-bg, #f9ede7);` : `background-color: var(--hover-bg, #f9ede7);`;
              drawerHtml += `<div class="f-drawer-promo" style="${bgStyle}">`;
              if (promoObj.url && !promoObj.url.includes('no-image')) {
                drawerHtml += `<img src="${promoObj.url}" alt="Promoción" class="f-drawer-promo-img" />`;
              }
              drawerHtml += `</div>`;
            }
            
            drawerHtml += `</div>`;
          }
          
          liDrawer.innerHTML = drawerHtml;
          drawerList.appendChild(liDrawer);
        }

        // 3. PREDICTIVE SEARCH CATEGORIES
        if (predictiveCategoriesList) {
          const liPredictive = document.createElement('li');
          liPredictive.innerHTML = `<a href="${category.url}">${formatDisplayTitle(category.name)}</a>`;
          predictiveCategoriesList.appendChild(liPredictive);
        }
      });

      // 4. SEARCH RESULTS SIDEBAR CONTEXTUAL LOGIC
      const facetsCategoryList = document.querySelector('.js-facets-category-list');
      const facetsCategoryTitle = document.querySelector('.js-facets-category-title');
      const breadcrumbCurrent = document.querySelector('.js-breadcrumb-current');

      const urlParams = new URLSearchParams(window.location.search);
      const catId = urlParams.get('cat_id');

      let targetCategory = null;
      if (catId) {
        targetCategory = data.find(c => c.id === catId);
      }

      if (facetsCategoryList) {
        facetsCategoryList.innerHTML = '';

        if (targetCategory) {
          // Render Subcategories
          if (facetsCategoryTitle) facetsCategoryTitle.textContent = 'Sub categorías';
          if (breadcrumbCurrent) breadcrumbCurrent.textContent = formatDisplayTitle(targetCategory.name);
          
          targetCategory.subcategories.forEach(sub => {
            const li = document.createElement('li');
            li.style.cssText = 'display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.6rem; line-height: 1.3;';
            const subUrl = sub.url ? sub.url : `/search?type=product&q=${encodeURIComponent(sub.name)}`;
            li.innerHTML = `<a href="${subUrl}" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; min-width: 0; text-decoration: none; color: inherit; font-weight: 400;">${formatDisplayTitle(sub.name)}</a><strong style="font-family: var(--font-poppins); font-weight: 700; font-size: var(--font-text-regular); color: var(--color-brand-blue-dark); flex-shrink: 0;">0</strong>`;
            facetsCategoryList.appendChild(li);
          });
        } else {
          // Render Root Categories
          if (facetsCategoryTitle) facetsCategoryTitle.textContent = 'Categorías';
          
          data.forEach(category => {
            const li = document.createElement('li');
            li.style.cssText = 'display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.6rem; line-height: 1.3;';
            li.innerHTML = `<a href="${category.url}" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-right: 5px; min-width: 0; text-decoration: none; color: inherit; font-weight: 400;">${formatDisplayTitle(category.name)}</a><strong style="font-family: var(--font-poppins); font-weight: 700; font-size: var(--font-text-regular); color: var(--color-brand-blue-dark); flex-shrink: 0;">0</strong>`;
            facetsCategoryList.appendChild(li);
          });
        }
      }

      // 5. SEARCH PAGE — SLIDING CLASSIFICATIONS BANNER (N2)
      const classificationsBanner = document.querySelector('.js-classifications-banner');
      const classificationsTrack = document.querySelector('.js-classifications-track');

      if (classificationsBanner && classificationsTrack && urlParams.get('labs') === '1' && window.laboratoriosJsonUrl) {
        // Entrada especial desde el botón "Laboratorios": el banner muestra
        // TODOS los fabricantes en vez de las subcategorías del mega menú.
        fetch(window.laboratoriosJsonUrl)
          .then(res => res.json())
          .then(labs => {
            classificationsBanner.style.removeProperty('--classifications-bg');
            classificationsTrack.innerHTML = '';
            labs.forEach(lab => {
              const card = document.createElement('a');
              card.className = 'f-classification-card';
              card.href = lab.url;
              card.setAttribute('role', 'listitem');
              card.draggable = false;

              const imageWrap = document.createElement('span');
              imageWrap.className = 'f-classification-icon f-classification-icon--default';
              imageWrap.innerHTML = mobileIcons['cat-007'] || mobileIcons['default'] || '';

              const label = document.createElement('span');
              label.className = 'f-classification-name';
              label.textContent = lab.name;

              card.appendChild(label);
              card.appendChild(imageWrap);
              classificationsTrack.appendChild(card);
            });
            classificationsBanner.style.display = '';
            initClassificationsSlider(classificationsBanner);
          })
          .catch(() => { classificationsBanner.style.display = 'none'; });
      } else if (classificationsBanner && classificationsTrack) {
        // Los links del mega menú a veces traen el valor del filtro con un NBSP
        // (espacio invisible) por delante (ej. " Maquillaje") — sin limpiar
        // eso, la comparación con el nombre real de la subcategoría nunca calza.
        const normalizeBanner = (text) => (text || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
        let activeSubName = normalizeBanner(urlParams.get('filter.p.m.custom.subcategoria_ecommerce') || urlParams.get('q') || '');
        if (activeSubName === '*') {
          activeSubName = normalizeBanner(urlParams.get('filter.p.m.custom.subcategoria_ecommerce') || '');
        }

        // Las subcategorías del mega menú apuntan a colecciones reales
        // (/collections/<handle>), sin el parámetro filter.p.m.custom.subcategoria_ecommerce
        // que este banner esperaba originalmente (pensado para el flujo de /search).
        // Por eso primero comparamos por path de la URL actual contra sub.url, y solo si
        // no hay match caemos al nombre por query param (flujo de búsqueda/predictive).
        //
        // OJO: en categorías donde las subcategorías comparten el mismo handle de
        // colección (ej. Cuidado del Bebé — se diferencian solo por query params, no
        // por path), TODAS tienen el mismo path, así que comparar solo por path
        // siempre "matcheaba" con la primera del array, sin importar cuál filtro
        // estuviera realmente activo. Por eso solo confiamos en el match por path
        // cuando es único entre las subcategorías; si varias comparten path, nos
        // vamos directo al match por nombre (el filtro real de la URL).
        const currentPath = window.location.pathname.replace(/\/+$/, '');
        let activeSub = null;
        if (targetCategory) {
          const subsWithCurrentPath = targetCategory.subcategories.filter(sub => {
            const subPath = sub.url ? sub.url.split('?')[0].replace(/\/+$/, '') : '';
            return subPath && subPath === currentPath;
          });
          activeSub = subsWithCurrentPath.length === 1
            ? subsWithCurrentPath[0]
            : targetCategory.subcategories.find(sub => normalizeBanner(sub.name) === activeSubName) || null;

          // Si seguimos sin encontrarla: categorías de handle compartido viendo una
          // clasificación N2 (los links de las cards N2 no incluyen el filtro de N1
          // en la URL). Buscamos a qué subcategoría pertenece esa clasificación y
          // mostramos sus hermanas, para no caer al listado raíz de subcategorías.
          if (!activeSub) {
            const n2Value = urlParams.get('filter.p.m.custom.subcategoria_n2_ecommerce');
            if (n2Value) {
              const n2Normalized = normalizeBanner(n2Value);
              activeSub = targetCategory.subcategories.find(sub =>
                (sub.classifications || []).some(c => normalizeBanner(c.name) === n2Normalized)
              ) || null;
            }
          }
        }

        // En categorías de handle compartido, dos subcategorías (N1) distintas pueden
        // tener una clasificación (N2) con el mismo nombre (ej. "Ojos" existe tanto en
        // "Cosméticos" como en "Maquillaje"). El link de la card solo llevaba el filtro
        // N2, así que no había forma de saber a cuál N1 pertenecía realmente — por eso
        // le agregamos también el filtro de la N1 activa, para que quede inequívoco.
        const withN1Filter = (clsUrl, subUrl) => {
          if (!clsUrl || !subUrl) return clsUrl;
          const n1Query = subUrl.split('?')[1];
          if (!n1Query) return clsUrl;
          const n1Params = new URLSearchParams(n1Query).getAll('filter.p.m.custom.subcategoria_ecommerce');
          if (!n1Params.length) return clsUrl;
          const [clsPath, clsQuery] = clsUrl.split('?');
          const merged = new URLSearchParams(clsQuery || '');
          n1Params.forEach(v => merged.append('filter.p.m.custom.subcategoria_ecommerce', v));
          return `${clsPath}?${merged.toString()}`;
        };

        const bannerItems = [];
        const seenItems = new Set();

        if (activeSub) {
          // Si estamos en una subcategoría, mostramos sus clasificaciones (N2)
          if (activeSub.classifications) {
            activeSub.classifications.forEach(cls => {
              const dedupeKey = cls.url || cls.name;
              if (seenItems.has(dedupeKey)) return;
              seenItems.add(dedupeKey);
              const clsUrlWithN1 = withN1Filter(cls.url, activeSub.url);
              bannerItems.push({
                name: cls.name,
                image: cls.image,
                url: clsUrlWithN1 ? addCatId(clsUrlWithN1, catId) : `/search?type=product&q=${encodeURIComponent(cls.name)}&cat_id=${catId}`
              });
            });
          }
        } else if (targetCategory) {
          // Si estamos solo en la categoría raíz, mostramos sus subcategorías (N1)
          if (targetCategory.subcategories) {
            targetCategory.subcategories.forEach(sub => {
              const dedupeKey = sub.url || sub.name;
              if (seenItems.has(dedupeKey)) return;
              seenItems.add(dedupeKey);
              bannerItems.push({
                name: sub.name,
                image: sub.image,
                url: sub.url ? addCatId(sub.url, catId) : `/search?type=product&q=${encodeURIComponent(sub.name)}&cat_id=${catId}`
              });
            });
          }
        }

        if (bannerItems.length > 0) {
          const categoryPromo = window.megaMenuPromos ? window.megaMenuPromos[catId] : null;
          const categoryImageFallback = categoryPromo && categoryPromo.url ? categoryPromo.url : '';

          // Mismo color de fondo que se ve en el hover de esta categoría en el mega menú.
          const { bg: bannerBg } = getFinalHoverColors(catId, targetCategory);
          if (bannerBg) {
            classificationsBanner.style.setProperty('--classifications-bg', bannerBg);
          }

          classificationsTrack.innerHTML = '';
          bannerItems.forEach(item => {
            const card = document.createElement('a');
            card.className = 'f-classification-card';
            card.href = item.url;
            card.setAttribute('role', 'listitem');
            card.draggable = false;

            const imageWrap = document.createElement('span');
            imageWrap.className = 'f-classification-icon';
            // Sin imagen propia todavía: usamos la imagen general de la categoría como placeholder.
            const imageSrc = item.image || categoryImageFallback;
            if (imageSrc) {
              const img = document.createElement('img');
              img.src = imageSrc;
              img.alt = '';
              img.loading = 'lazy';
              img.draggable = false;
              imageWrap.appendChild(img);
            } else {
              imageWrap.classList.add('f-classification-icon--default');
              imageWrap.innerHTML = mobileIcons[catId] || mobileIcons['default'] || '';
            }

            const label = document.createElement('span');
            label.className = 'f-classification-name';
            label.textContent = formatDisplayTitle(item.name);

            // Texto a la izquierda, imagen a la derecha.
            card.appendChild(label);
            card.appendChild(imageWrap);
            classificationsTrack.appendChild(card);
          });

          classificationsBanner.style.display = '';
          initClassificationsSlider(classificationsBanner);
        } else {
          classificationsBanner.style.display = 'none';
        }
      }

      // 6. MIGAS DE PAN — insertar los niveles intermedios (categoría padre N0
      // y, en producto sin contexto de colección, también la subcategoría N1)
      // para poder navegar por toda la ruta (Inicio > Categoría padre >
      // Subcategoría > Producto) y no solo Inicio > último nivel.
      const breadcrumbNav = document.querySelector('.js-breadcrumb');
      if (breadcrumbNav) {
        const inicioLink = breadcrumbNav.querySelector('a');
        const firstSeparator = inicioLink ? inicioLink.nextElementSibling : null;
        const normalizeCrumb = (text) => (text || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();

        const insertCrumbs = (crumbs) => {
          if (!firstSeparator || !crumbs.length) return;
          const nodes = [];
          crumbs.forEach(crumb => {
            const link = document.createElement('a');
            // El carrusel de clasificaciones (sección 5) solo sabe qué mostrar si
            // la URL trae cat_id — igual que los links del mega menú.
            link.href = crumb.catId ? addCatId(crumb.url, crumb.catId) : crumb.url;
            link.textContent = formatDisplayTitle(crumb.name);
            const separator = document.createElement('span');
            separator.className = 'breadcrumb-separator';
            separator.textContent = '/';
            nodes.push(link, separator);
          });
          firstSeparator.after(...nodes);
        };

        // Agrega un nivel al FINAL de la miga de pan: convierte el crumb actual
        // (el último, marcado "current") en link, y pone el nuevo nombre como current.
        const appendCrumb = (currentCrumbUrl, newCrumbName, catId) => {
          const currentSpan = breadcrumbNav.querySelector('.breadcrumb-current');
          if (!currentSpan) return;
          const link = document.createElement('a');
          link.href = catId ? addCatId(currentCrumbUrl, catId) : currentCrumbUrl;
          link.textContent = currentSpan.textContent;
          const separator = document.createElement('span');
          separator.className = 'breadcrumb-separator';
          separator.textContent = '/';
          const newCurrent = document.createElement('span');
          newCurrent.className = 'breadcrumb-current';
          newCurrent.textContent = formatDisplayTitle(newCrumbName);
          currentSpan.replaceWith(link, separator, newCurrent);
        };

        let matchedSubcategory = null;
        let matchedParentCategory = null;
        let n2AlreadyAppended = false;

        const currentHandle = breadcrumbNav.dataset.collectionHandle;
        if (currentHandle) {
          // Colección (N0 o N1) o producto abierto dentro del contexto de una colección:
          // si el nivel actual es una subcategoría (N1), insertamos el link a su categoría padre (N0).
          const topCategory = data.find(cat => cat.url === `/collections/${currentHandle}`);
          if (!topCategory) {
            data.some(cat => {
              const sub = (cat.subcategories || []).find(s => s.url && s.url.split('?')[0].replace(/\/+$/, '') === `/collections/${currentHandle}`);
              if (sub) {
                matchedParentCategory = cat;
                matchedSubcategory = sub;
                return true;
              }
              return false;
            });
            if (matchedParentCategory) insertCrumbs([{ name: matchedParentCategory.name, url: matchedParentCategory.url, catId: matchedParentCategory.id }]);
          } else {
            // Categorías donde las subcategorías (N1) no tienen colección propia,
            // comparten el mismo handle que la categoría (N0) y se diferencian solo
            // por el filtro subcategoria_ecommerce (ej. Cuidado del Bebé). Ahí no hay
            // nada que insertar entre Inicio y la N0 por handle — pero si viene un
            // filtro de N1 y/o de clasificación N2 en la URL, sí podemos ubicarlos
            // dentro del árbol y armar los niveles igual que en el caso normal.
            //
            // OJO: dos N1 distintas pueden tener una clasificación N2 con el MISMO
            // nombre (ej. "Ojos" existe en "Cosméticos" y en "Maquillaje"). Por eso,
            // si el filtro de N1 viene en la URL, resolvemos primero esa N1 y
            // buscamos el N2 SOLO dentro de sus propias clasificaciones — nunca en
            // todas las subcategorías, para no quedarnos con la primera que
            // coincida por nombre sin importar a cuál pertenece de verdad.
            const n1ValueTop = urlParams.get('filter.p.m.custom.subcategoria_ecommerce');
            const n2ValueTop = urlParams.get('filter.p.m.custom.subcategoria_n2_ecommerce');
            let matchedSubTop = null;
            if (n1ValueTop) {
              const n1NormalizedTop = normalizeCrumb(n1ValueTop);
              matchedSubTop = (topCategory.subcategories || []).find(sub => normalizeCrumb(sub.name) === n1NormalizedTop) || null;
            }

            if (n2ValueTop) {
              const n2NormalizedTop = normalizeCrumb(n2ValueTop);
              if (matchedSubTop) {
                // N1 conocida: el N2 tiene que ser una de SUS clasificaciones.
                const cls = (matchedSubTop.classifications || []).find(c => normalizeCrumb(c.name) === n2NormalizedTop);
                if (cls) {
                  matchedParentCategory = topCategory;
                  matchedSubcategory = matchedSubTop;
                  appendCrumb(topCategory.url, matchedSubTop.name, topCategory.id);
                  appendCrumb(matchedSubTop.url, cls.name, topCategory.id);
                  n2AlreadyAppended = true;
                }
              } else {
                // Sin filtro de N1 en la URL (links viejos / clasificaciones sin
                // N1 ambigua): único recurso es buscar en todas las subcategorías.
                (topCategory.subcategories || []).some(sub => {
                  const cls = (sub.classifications || []).find(c => normalizeCrumb(c.name) === n2NormalizedTop);
                  if (cls) {
                    matchedParentCategory = topCategory;
                    matchedSubcategory = sub;
                    appendCrumb(topCategory.url, sub.name, topCategory.id);
                    appendCrumb(sub.url, cls.name, topCategory.id);
                    n2AlreadyAppended = true;
                    return true;
                  }
                  return false;
                });
              }
            }

            // Sin clasificación N2 (o no se encontró): si al menos hay un filtro de
            // subcategoría N1 en la URL (el caso normal al entrar por el mega menú
            // a una de estas subcategorías), la agregamos como 3er nivel.
            if (!n2AlreadyAppended && matchedSubTop) {
              matchedParentCategory = topCategory;
              matchedSubcategory = matchedSubTop;
              appendCrumb(topCategory.url, matchedSubTop.name, topCategory.id);
            }
          }
        } else if (breadcrumbNav.dataset.productSubcategoria) {
          // Producto abierto sin contexto de colección (caso más común: los links de
          // producto no llevan la colección en la URL). Usamos el metafield de
          // subcategoría del producto para ubicarlo dentro del árbol del mega menú
          // y así poder mostrar tanto la categoría padre (N0) como la subcategoría (N1).
          const normalize = (text) => (text || '').replace(/ /g, ' ').trim().toLowerCase();
          const targetSub = normalize(breadcrumbNav.dataset.productSubcategoria);
          let foundParent = null;
          let foundSub = null;
          data.some(cat => {
            const sub = (cat.subcategories || []).find(s => normalize(s.name) === targetSub);
            if (sub) {
              foundParent = cat;
              foundSub = sub;
              return true;
            }
            return false;
          });
          if (foundParent && foundSub) {
            insertCrumbs([
              { name: foundParent.name, url: foundParent.url, catId: foundParent.id },
              { name: foundSub.name, url: foundSub.url, catId: foundParent.id }
            ]);
          }
        }

        // 3er nivel: si además hay una clasificación N2 activa en la URL (al
        // entrar por una card del carrusel de clasificaciones), la agregamos
        // como nivel final, y el N1 (que hasta ahora era el nivel final) pasa
        // a ser un link en vez de texto suelto.
        if (matchedSubcategory && !n2AlreadyAppended) {
          const n2Value = urlParams.get('filter.p.m.custom.subcategoria_n2_ecommerce');
          if (n2Value) {
            const n2Normalized = normalizeCrumb(n2Value);
            const matchedClassification = (matchedSubcategory.classifications || []).find(c => normalizeCrumb(c.name) === n2Normalized);
            if (matchedClassification) {
              appendCrumb(matchedSubcategory.url, matchedClassification.name, matchedParentCategory && matchedParentCategory.id);
            }
          }
        }
      }

      initClicks();
      initDrawerEvents();
    })
    .catch(err => console.error("Error loading mock menu:", err));

  function initClassificationsSlider(container) {
    if (container.dataset.sliderInitialized === 'true') return;
    container.dataset.sliderInitialized = 'true';

    const track = container.querySelector('.js-classifications-track');
    const prevBtn = container.querySelector('.js-classifications-prev');
    const nextBtn = container.querySelector('.js-classifications-next');
    const speedSeconds = Number(container.dataset.autoplaySpeed) || 4;
    let autoplayTimer = null;
    let resumeTimer = null;

    function cardStep() {
      const card = track.querySelector('.f-classification-card');
      if (!card) return track.clientWidth;
      const trackStyle = getComputedStyle(track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0');
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByStep(direction) {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) return;
      let target = track.scrollLeft + (cardStep() * direction);
      if (target < 0) target = maxScroll;
      if (target > maxScroll) target = 0;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (track.scrollWidth <= track.clientWidth) return;
      autoplayTimer = setInterval(() => scrollByStep(1), speedSeconds * 1000);
    }

    function pauseThenResume() {
      stopAutoplay();
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(startAutoplay, speedSeconds * 1000);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => { scrollByStep(-1); pauseThenResume(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => { scrollByStep(1); pauseThenResume(); });
    }

    ['touchstart', 'wheel'].forEach(evt => {
      track.addEventListener(evt, pauseThenResume, { passive: true });
    });
    track.addEventListener('mouseenter', stopAutoplay);
    track.addEventListener('mouseleave', startAutoplay);

    // Deslizar libremente arrastrando con el mouse (touch/trackpad ya funcionan nativos).
    let isDragging = false;
    let dragMoved = false;
    let dragStartX = 0;
    let dragStartScroll = 0;

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
    }

    // El navegador arrastra <a>/<img> de forma nativa por defecto; eso "roba" los
    // eventos de mouse a mitad de gesto y deja isDragging pegado en true, haciendo
    // que el track se mueva solo con el hover. Lo bloqueamos por completo.
    track.addEventListener('dragstart', (e) => e.preventDefault());

    track.addEventListener('mousedown', (e) => {
      e.preventDefault();
      isDragging = true;
      dragMoved = false;
      dragStartX = e.pageX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      pauseThenResume();
    });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      if (e.buttons === 0) {
        // Se soltó el botón fuera de la ventana y no llegó el mouseup.
        endDrag();
        return;
      }
      const delta = e.pageX - dragStartX;
      if (Math.abs(delta) > 5) dragMoved = true;
      track.scrollLeft = dragStartScroll - delta;
    });

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('blur', endDrag);

    // Evita que un arrastre termine navegando el link de la tarjeta.
    track.addEventListener('click', (e) => {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);

    startAutoplay();
  }

  function initClicks() {
    if (!navList) return;
    const navItems = document.querySelectorAll('.f-nav-item');
    navItems.forEach(item => {
      item.addEventListener('click', function(e) {
        e.preventDefault(); // Evita navegar por ahora
        const container = this.closest('.f-nav-item-container');
        if (container && container.querySelector('.f-mega-menu')) {
          document.querySelectorAll('.f-nav-item-container.is-active').forEach(activeItem => {
            if (activeItem !== container) activeItem.classList.remove('is-active');
          });
          container.classList.toggle('is-active');
        }
      });
    });
    
    // Cerrar mega menu al hacer click afuera
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.f-nav')) {
        document.querySelectorAll('.f-nav-item-container.is-active').forEach(activeItem => {
          activeItem.classList.remove('is-active');
        });
      }
    });
  }

  function initDrawerEvents() {
    // Drawer open/close
    if (menuBtn) {
      menuBtn.addEventListener('click', () => {
        drawer.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden'; // Evitar scroll de fondo
        document.documentElement.style.overflow = 'hidden';
      });
    }
    
    const closeDrawer = () => {
      if(drawer) drawer.classList.remove('is-open');
      if(overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Accordion en el drawer
    const drawerLinks = document.querySelectorAll('.f-drawer-menu-link');
    drawerLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const item = this.parentElement;
        const submenu = item.querySelector('.f-drawer-submenu');
        if (submenu) {
          e.preventDefault();
          item.classList.toggle('is-open');
        }
      });
    });
  }
});
